import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { EmailConfigurationService } from "../../../modules/email/components/email.service";

import { showNotification } from "../../../shared/utils/utils";

const emailConfigurationService = new EmailConfigurationService();

export const getEmailConfigurations = createAsyncThunk(
  "emailConfiguration/list",
  async (
    data: { params: any; body: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await emailConfigurationService.getEmailConfigurations(
        data.params,
        data.body
      );

      return response.data;
    } catch (error: any) {
      showNotification(
        error?.response?.data?.message || "Failed to fetch email configurations",
        "error"
      );

      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createEmailConfiguration = createAsyncThunk(
  "emailConfiguration/create",
  async (data: any, { rejectWithValue }) => {
    try {
      const response =
        await emailConfigurationService.createEmailConfiguration(data);

      return response.data;
    } catch (error: any) {
      showNotification(
        error?.response?.data?.message || "Failed to create email configuration",
        "error"
      );

      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateEmailConfiguration = createAsyncThunk(
  "emailConfiguration/update",
  async (
    data: { id: string; body: any },
    { rejectWithValue }
  ) => {
    try {
      const response =
        await emailConfigurationService.updateEmailConfiguration(
          data.id,
          data.body
        );

      return response.data;
    } catch (error: any) {
      showNotification(
        error?.response?.data?.message || "Failed to update email configuration",
        "error"
      );

      return rejectWithValue(error?.response?.data);
    }
  }
);

export const sendTestEmail = createAsyncThunk(
  "emailConfiguration/sendTestEmail",
  async (
    data: { id: string; notificationKey: string },
    { rejectWithValue }
  ) => {
    try {
      const response =
        await emailConfigurationService.sendTestEmail(
          data.id,
          data.notificationKey
        );

      return response.data;
    } catch (error: any) {
      showNotification(
        error?.response?.data?.message ||
        "Failed to send test email",
        "error"
      );

      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteEmailConfiguration = createAsyncThunk(
  "emailConfiguration/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      const response =
        await emailConfigurationService.deleteEmailConfiguration(id);

      return response.data;
    } catch (error: any) {
      showNotification(
        error?.response?.data?.message || "Failed to delete email configuration",
        "error"
      );

      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  loading: false,
  list: [],
  pagination: {
    page: 1,
    limit: 15,
    total: 0,
  },
  error: null as string | null,
};

const emailConfigurationSlice = createSlice({
  name: "email",

  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder

      // GET EMAIL CONFIGURATIONS
      .addCase(getEmailConfigurations.pending, (state) => {
        state.loading = true;
      })

      // .addCase(getEmailConfigurations.fulfilled, (state, action) => {
      //   state.loading = false;

      //   state.list = action.payload?.data || [];

      //   state.pagination = action.payload?.pagination || null;
      // })
      .addCase(getEmailConfigurations.fulfilled, (state, action) => {
        state.loading = false;

        state.list = action.payload?.data || [];

        state.pagination = action.payload?.pagination
          ? action.payload.pagination
          : {
            page: action.payload?.page ?? 1,
            limit: action.payload?.limit ?? 15,
            total: action.payload?.total ?? 0,
          };
      })

      .addCase(getEmailConfigurations.rejected, (state, action) => {
        state.loading = false;

        state.error = action.payload as any;
      })

      // CREATE EMAIL CONFIGURATION
      .addCase(createEmailConfiguration.pending, (state) => {
        state.loading = true;
      })

      .addCase(createEmailConfiguration.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(createEmailConfiguration.rejected, (state) => {
        state.loading = false;
      })

      // UPDATE EMAIL CONFIGURATION
      .addCase(updateEmailConfiguration.pending, (state) => {
        state.loading = true;
      })

      .addCase(updateEmailConfiguration.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateEmailConfiguration.rejected, (state) => {
        state.loading = false;
      })

      .addCase(sendTestEmail.pending, (state) => {
        state.loading = true;
      })

      .addCase(sendTestEmail.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(sendTestEmail.rejected, (state) => {
        state.loading = false;
      })
      // DELETE EMAIL CONFIGURATION
      .addCase(deleteEmailConfiguration.pending, (state) => {
        state.loading = true;
      })

      .addCase(deleteEmailConfiguration.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(deleteEmailConfiguration.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default emailConfigurationSlice.reducer;